import { green } from '@mui/material/colors';

export const reviewDiffStyles = {
	changeLabel: {
		fontSize: '0.75rem',
		fontWeight: 500,
		color: '#9CA3AF',
		textTransform: 'uppercase',
		letterSpacing: '0.05em'
	},

	changeRow: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'baseline',
		columnGap: 1,
		rowGap: 0.25
	},

	tag: {
		display: 'inline-block',
		flexShrink: 0,
		fontSize: '0.75rem',
		fontWeight: 400
	},

	addedTag: {
		color: green[600]
	},

	removedTag: {
		color: 'error.light'
	},

	previousValue: {
		fontSize: '0.875rem',
		textDecoration: 'line-through',
		color: 'text.secondary'
	},

	newValue: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'text.primary'
	},

	removedValue: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'text.disabled'
	},

	arrowIcon: {
		fontSize: '1.125rem',
		color: 'text.secondary',
		alignSelf: 'center'
	}
};

export const reviewModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		width: '100%'
	},

	noChangesText: {
		p: 2,
		color: 'text.secondary',
		fontStyle: 'italic'
	},

	attachmentsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		mb: 3
	},

	sectionTitle: {
		fontSize: '1.25rem',
		fontWeight: 700,
		color: 'text.primary'
	}
};
